import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AdminPageHeader, Field, Select, Toggle, ConfirmDeleteButton } from "./_helpers";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";

export default function AdminUsers() {
  const [items, setItems] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [roles, setRoles] = useState([]);
  const [editing, setEditing] = useState(null);
  const empty = { email: "", username: "", password: "", role: "user", first_name: "", last_name: "", province_id: "", is_active: true };
  const [f, setF] = useState(empty);

  const load = () => api.get("/users").then((r) => setItems(r.data || []));
  useEffect(() => {
    load();
    api.get("/provinces?active_only=false").then((r) => setProvinces(r.data));
    api.get("/users/roles").then((r) => setRoles(r.data));
  }, []);

  const save = async () => {
    try {
      if (editing) await api.put(`/users/${editing}`, f);
      else await api.post("/users", f);
      toast.success("Kaydedildi");
      setEditing(null); setF(empty); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };

  const remove = async (id) => {
    try { await api.delete(`/users/${id}`); load(); } catch { toast.error("Hata"); }
  };

  const edit = (u) => { setEditing(u.id); setF({ ...u, password: "", province_id: u.province_id || "" }); };

  return (
    <div>
      <AdminPageHeader title="Kullanıcılar & Roller" subtitle={`${items.length} kullanıcı`} />
      <div className="grid md:grid-cols-3 gap-5">
        <div className="md:col-span-2 bg-white border border-gray-100 rounded-lg">
          <table className="w-full text-sm">
            <thead className="text-left bg-gray-50">
              <tr><th className="px-3 py-2">Email</th><th className="px-3 py-2">Rol</th><th className="px-3 py-2">İl</th><th className="px-3 py-2">Aktif</th><th className="px-3 py-2"></th></tr>
            </thead>
            <tbody>
              {items.map((u) => (
                <tr key={u.id} className="border-t">
                  <td className="px-3 py-2">{u.email}</td>
                  <td className="px-3 py-2"><span className="text-xs px-2 py-0.5 bg-gray-100 rounded">{u.role}</span></td>
                  <td className="px-3 py-2 text-xs">{provinces.find((p) => p.id === u.province_id)?.name || "-"}</td>
                  <td className="px-3 py-2">{u.is_active ? "✅" : "❌"}</td>
                  <td className="px-3 py-2 text-right space-x-2">
                    <button onClick={() => edit(u)} className="text-blue-600 text-xs">Düzenle</button>
                    <ConfirmDeleteButton onConfirm={() => remove(u.id)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="bg-white border border-gray-100 rounded-lg p-4 space-y-3">
          <div className="flex items-center justify-between">
            <h3 className="font-bold">{editing ? "Düzenle" : "Yeni Kullanıcı"}</h3>
            {editing && <button onClick={() => { setEditing(null); setF(empty); }} className="text-gray-500"><X className="w-4 h-4" /></button>}
          </div>
          <Field label="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
          <Field label="Kullanıcı adı" value={f.username} onChange={(e) => setF({ ...f, username: e.target.value })} />
          <Field label={editing ? "Yeni şifre (değiştirmek istemiyorsanız boş bırakın)" : "Şifre"} type="password" value={f.password || ""} onChange={(e) => setF({ ...f, password: e.target.value })} />
          <Select label="Rol" value={f.role} options={roles.map((r) => ({ value: r.value, label: r.label }))} onChange={(e) => setF({ ...f, role: e.target.value })} />
          <Select label="İl" value={f.province_id || ""} options={[{ value: "", label: "Genel/Yok" }, ...provinces.map((p) => ({ value: p.id, label: p.name }))]} onChange={(e) => setF({ ...f, province_id: e.target.value })} />
          <Field label="İsim" value={f.first_name || ""} onChange={(e) => setF({ ...f, first_name: e.target.value })} />
          <Field label="Soyisim" value={f.last_name || ""} onChange={(e) => setF({ ...f, last_name: e.target.value })} />
          <Toggle label="Aktif" value={f.is_active} onChange={(v) => setF({ ...f, is_active: v })} />
          <button onClick={save} className="w-full px-4 py-2 bg-[#e11d2a] text-white rounded-md text-sm font-semibold flex items-center justify-center gap-1"><Plus className="w-4 h-4" /> Kaydet</button>
        </div>
      </div>
    </div>
  );
}
